// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const gu: ChromeTranslations = {
  'nav.nextPage': 'આગળનું પાન →',
  'nav.previousPage': '← પાછળનું પાન',
  'nav.continueToLevel': 'સ્તર પર ચાલુ રાખ →',
  'nav.backToMenu': 'મેનુ પર પાછા →',
  'howto.page': '{total}માંથી પાન {n}',
  'options.title': 'વિકલ્પો',
  'ui.language': 'ભાષા',
};
